import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './OrderNow.css';
import OrderShortSummaryWithImage from '../OrderShortSummaryWithImage/OrderShortSummaryWithImage';






function OrderNow() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const { productsInCart, totalAmount } = location.state || {}; // Retrieve state passed from ProductDisplay

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [order, setOrder] = useState(false);

  const shippingCharges = 200;

  useEffect(() => {
    // If no cart data is passed, redirect to the CartItems page
    if (!productsInCart) {
      navigate('/'); // Use React Router to navigate without reloading the page
    }
  }, [productsInCart, navigate]);

  const createOrderMessage = () => {
    let message = `Hello, I would like to place an order with the following items:_\n\n`;

    productsInCart.forEach((product) => {
      const { name, size, quantity, price } = product;
      let adjustedPrice = price;

      if (size === "Unstitched") {
        adjustedPrice = price - 1000;
      }

      message += `> Title: ${name}\n> Price: PKR ${adjustedPrice}\n> Size: ${size}\n> Quantity: ${quantity}\n> Total: PKR ${adjustedPrice * quantity}\n\n`;
    });

    message += `Subtotal: PKR ${totalAmount - shippingCharges}\nShipping: PKR ${shippingCharges}\nTotal: PKR ${totalAmount}\n\n`;
    
    message += `*Shipping Detail:*\nName: ${name} \nEmail: ${email}\nPhone: ${phone}\nShipping Address: ${address}\n\n`;
    message += `Payment Method: Cash on Delivery (COD)\n\n`;
    message += `Please confirm the order.`;

    return message;
  };
 
  const handleSubmitOrder = async () => {
    // Create the order message for WhatsApp
    window.scrollTo(0, 0); 

    const message = createOrderMessage();
  
    // Send the order data to the backend
    const orderData = {
      name,
      email,
      phone,
      address,
      products: productsInCart,
      totalAmount,
      paymentMethod: 'Cash on Delivery',  // Add payment method here
    };

    try {
      const response = await fetch("https://emre.pk/api/submit-order", {  // Correct endpoint for production
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
      });

      const textResponse = await response.text(); // Get the raw text response
      console.log("Response from server:", textResponse); // Log it for debugging

      if (response.ok) {
        
        await fetch("https://formsubmit.co/ajax/arbabb963@gmail.com", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            _subject: "🛒 New Order from EMRE",
            _template: "table",
            _captcha: "false",
            message: createOrderMessage(),
          }),
        });
        
        // If order is saved, open WhatsApp
        const whatsappURL = `https://wa.me/+923203218800?text=${encodeURIComponent(message)}`;

        // Reset form and navigate to order summary
        setOrder(true);
        setName('');
        setEmail('');
        setPhone('');
        setAddress('');

        // Redirect to OrderSummary page
       
          navigate('/order-summary', { state: { orderData } });
        
      } else {
        alert("Error: " + textResponse); // Show the response error if not OK
      }
    } catch (error) {
      console.error("Error submitting order:", error);
      alert("There was an error while placing your order.");
    }
  };

  return (
    <div className="page">
      
      {productsInCart && (
  <OrderShortSummaryWithImage 
    products={productsInCart} 
    totalAmount={totalAmount} 
    shippingCharges={shippingCharges} 
  />
)}

      <div className="order-now-container">
      <div className="order-now-form">
        <h1>Shipping Information</h1>

        <div className="form-section">
          <label htmlFor="name">Full Name</label>
          <input 
            id="name" 
            type="text" 
            placeholder="Enter your full name" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
          />
        </div>

        <div className="form-section">
          <label htmlFor="email">Email Address</label>
          <input 
            id="email" 
            type="email" 
            placeholder="Enter your email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
          />
        </div>

        <div className="form-section">
          <label htmlFor="phone">Phone Number</label>
          <input 
            id="phone" 
            type="text" 
            placeholder="Enter your phone number" 
            value={phone} 
            onChange={(e) => setPhone(e.target.value)} 
          />
        </div>

        <div className="form-section">
          <label htmlFor="address">Shipping Address</label>
          <textarea 
            id="address" 
            placeholder="Enter your full address"
            rows="4"
            value={address} 
            onChange={(e) => setAddress(e.target.value)} 
          />
        </div>

        <div className="payment-method">
          <h3>Payment Method</h3>
          <div>
            <label>
              <input type="radio" checked disabled />
              &nbsp; Cash on Delivery (COD) 
            </label>
          </div>
        </div>

        <button onClick={handleSubmitOrder}>Submit Order</button>

        {order && <p className="success-message">Order has been placed successfully!</p>}
      </div>
      </div>
    </div>
    
  );
}

export default OrderNow;
